import type { Person } from '@vigeo/shared';
import { OfferStageStates, type OfferStageRequest } from '@/features/offer-stage';
import { usePersonStyles } from './styles.js';

/** Step 2. Moved unchanged from `pages/PersonPage.tsx` (#462 §5). */
export interface OfferAndStageStepProps {
  readonly person: Person;
  readonly canEdit: boolean;
  readonly roleLabel: string | null;
  readonly onGoToDocuments: () => void;
  readonly initialRequest: OfferStageRequest;
  readonly onRequestConsumed: () => void;
}

export function OfferAndStageStep({ person, canEdit, roleLabel, onGoToDocuments, initialRequest, onRequestConsumed }: OfferAndStageStepProps) {
  const styles = usePersonStyles();
  return <div className={styles.page}>
    {/*
      06b rows 1.2 to 1.4, 2.1, 2.2 and 2.5, one at a time (#440). `OfferStageStates` chooses which
      from the offer's own record, and draws `OfferStageSection` itself — that section answers for
      every state outside a candidate's offer work (#346), so no older panel shows through.
    */}
    <OfferStageStates person={person} canEdit={canEdit} roleLabel={roleLabel} onGoToDocuments={onGoToDocuments}
      initialRequest={initialRequest} onRequestConsumed={onRequestConsumed} />
  </div>;
}
